// 获取元素是否在可视区域
function MB_isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= -rect.height &&
    rect.left >= -rect.width &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) + rect.height &&
    rect.right <=
      (window.innerWidth || document.documentElement.clientWidth) + rect.width
  )
} 
function MB_is_mobile() {
  return window.innerWidth <= 768;
}
function MB_getPriceData(e) {
  const target = e.find("ins .money").lenght > 0 ? e.find("ins .money") : e.find(".money")
  let string = target.text()
  if(e.attr('data-basecut4')){
    string = e.attr('data-basecut4')
  }
  const re = /^(\W+)((\d+)(\.\d+)?)/.exec(string)
  return {
    currency: re[1],
    price: Number(re[2]),
  }
}
function MB_sleep(t = 1000) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve()
    }, t)
  })
}
async function MB_loadScript(url) {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;
  document.body.appendChild(script);
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
  return new Promise((resolve, reject) => {
    script.addEventListener("load", resolve);
  })
}
async function MB_jsDeferHandle(method, waitObj = []) {
  for (let i = 0; i < 1000; i++) {
    let status = true;
    for (const item of waitObj) {
      // console.log(`${item}:${typeof(item)}`, item)
      if(typeof(item) == 'string'){
        if (!window[item]) {
          status = false;
          break;
        }
      }else if(typeof(item) == undefined || item == undefined){ 
        status = false;
        break;
      }
    }
    if (status) break
    await MB_sleep(50)
  }
  method();
}
async function MB_waitElementReady(element, isExist=true, preTime=10, total=999) {
  for (let i = 0; i < total; i++) {
    if(typeof(element) == 'string'){
      if ((document.querySelectorAll(element).length > 0 && isExist) || (document.querySelectorAll(element).length == 0 && !isExist)) {
        break
      }
    }else{
      if ((element.length > 0 && isExist) || (element.length == 0 && !isExist)) {
        break
      }

    }
    await MB_sleep(preTime)
  }
}
function MB_randomIntiNumber(long=1000000000){
  return Math.ceil(Math.random()*long)
}
async function MB_apiFetch(url, type='GET',data=null) {
    const params = {
      method: type,
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    }
    data && (params['body'] = JSON.stringify(data))
    const response = await fetch(url, params)
    return response.json()
}
function MB_setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function MB_getCookie(cname) {
  const decodedCookie = decodeURIComponent(document.cookie);
  const reg = new RegExp(`${cname}=(.*?);`)
  const res = reg.exec(decodedCookie)
  return res ? res[1] : null
}
async function MB_flickity_carousel_current_cell(element){
  const el = $(element).find('.t4s-flicky-slider')[0]
  // const carousel = el.flickityt4s.$carousel
  const flkty = el.flickityt4s.flkty
  const index = flkty.selectedIndex
  // console.log(el, index)
  return index
}
async function MB_flickity_carousel_select_cell(element, index=0){
  let el
  if(typeof(element) == 'string'){
    el = $(`${element}`)
  }else{
    el = element
  }
  // await MB_waitElementReady(`${element} .t4s-flicky-slider [data-select-flickity]`)
  // $(`${element}`).each(function(){
  el.each(function(){
    const el = $(this).find('.t4s-flicky-slider')[0]
    const carousel = el.flickityt4s.$carousel
    const flkty = el.flickityt4s.flkty
    // console.log(carousel, flkty)
    carousel.flickityt4s('selectCell', index)
    // flkty.option('draggable',false)
    // flkty.option('adaptiveHeight',true)
    // flkty.option('autoplay',false)
    // flkty.options.draggable = false
    flkty.resize();
    flkty.reloadCells();
  })
}
function MB_getUrlParam(paramName) {
  const regex = new RegExp(`${paramName}=(.*?)(&|$)`, 'g');
  const matches = location.search.match(regex);
  if(matches){
    const values = matches.map(match => match.split('=')[1].replace(/&/, ''));
    if(values.length>1){
      return values
    }else{
      return values[0].replace(/&/, '')
    }
  }else{
    return null
  }
}
function MB_change_url_params(name, value){
  console.log(name, value)
  let currentUrl = new URL(window.location.href);
  // 修改参数
  currentUrl.searchParams.set(name, value);
  // 使用 history.pushState 更新 URL
  history.pushState({}, '', currentUrl.toString());
}
function MB_download_file(event, element, url) {
  console.log(event, element, url)
  event.preventDefault();
  // return 
  const filename = url.substring(url.lastIndexOf('/') + 1).split("?")[0];
  $(element).addClass('active')
  fetch(url)
      .then(response => {
        console.log('ok123')
        return response.blob()
      })
      .then(blob => {
          console.log('downloading ok')
          const a = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url); // 释放内存
          $(element).removeClass('active')

      })
      .catch(err => {
        $(element).removeClass('active')
        console.error('下载失败:', err)
      });
}

  async function MB_buyItNowAtListItem(){
    const el = '.buy_it_now_mibao_item'
    await MB_waitElementReady(el, preTime=100, total=100)
    $(el).off('click').click(async function(e){
      $(this).attr('aria-disabled',true)
      $(this).addClass('is--loading')
      e.preventDefault()

      let quantity = 1
      if($(this).closest('.t4s-product-quick-view').length > 0){
        quantity = $(this).closest('.t4s-product-quick-view').find('[data-quantity-value]').val()
      }
      const id = $(this).data('variant-id')
      const data = {
        form_type: "product",
        utf8: "✓",
        id,
        quantity,
      }
      // console.log(data)
      const response = await MB_apiFetch(`${T4Sroutes.cart_add_url}.js`, "POST", data)
      // console.log(response)
      // $(this).removeAttr('aria-disabled')
      // $(this).removeClass('is--loading')
      // $(this).removeAttr('disabled')
      location.href = '/checkout'
    })
  }
  async function MB_clear_cart(opend_drawer=false){
    await MB_apiFetch('/cart/clear.js', "GET")
    T4SThemeSP.Cart.getToFetch(opend_drawer)
  }

(function(){
  async function userRecommendedListHandle(){
    await MB_waitElementReady(".user_recommended .t4s-col-item")
    $(".user_recommended .t4s-col-item").first().addClass('hover')
    $(".user_recommended .t4s-col-item").mouseover(function(){
      $(this).parent().find('.t4s-col-item').removeClass('hover')
      $(this).addClass('hover')
    })
    
  }
  async function blogTrendingRecipesHandle(){
    await MB_waitElementReady(".template-index .t4s-blog-post-manual .t4s-section-title")
    $(".template-index .t4s-blog-post-manual .t4s-section-title").click(function(){
      location.href = "/blogs/news"
    })
    
  }
  function faqListHandle(){
    $(".faq_list li").click(function(){
      $(".faq_list li").removeClass('is_active')
      $(this).toggleClass('is_active')
      // $(this).find('.content').slideToggle()
    })
  }
  async function menuCollectionList(){
    await MB_waitElementReady(".mibao_menu_collection_title_list")
    $(".mibao_menu_collection_title_list li").on('mouseover', function(){
      const index = $(this).index()
      const parent = $(this).parents('.t4s-row')
      // console.log(index, parent)
      parent.find('.is_selected').removeClass('is_selected')
      parent.find('.mibao_menu_collection_list').remove('is_selected')
      $(this).addClass('is_selected')
      $(parent.find('.mibao_menu_collection_list')[index]).addClass('is_selected')
    })
    
  }
  async function pcMenuAction(){
    await MB_waitElementReady(".t4s-section-header__bot")
    $(".t4s-section-header__bot").on('mouseover', function(){
      $(this).addClass('is_hover')
    })
    $(".t4s-section-header__bot").on('mouseout', function(){
      $(this).removeClass('is_hover')
    })
    
  }
  async function mobileMenuAction(){
    await MB_waitElementReady("#t4s-menu-drawer .mobile_menu_li", preTime=600, total=100)
    await MB_sleep(1000)
    console.log('mobile menu done')
    $("#t4s-menu-drawer .mobile_menu_li .item_title").click(function(){
      $(this).parent().addClass('is_select')
    })
    $("#t4s-menu-drawer .mobile_menu_li .button_back").click(function(){
      $(this).parent().removeClass('is_select')
    })

    $("#t4s-menu-drawer .mibao_mobile_menu_item>li>a").click(function(){
      // $("#t4s-menu-drawer .mibao_mobile_menu_item>li").removeClass('is_select')
      const parent = $(this).parent()
      $("#t4s-menu-drawer .mibao_mobile_menu_item>li").each(function(){
        if($(this)[0] != parent[0]){
          $(this).removeClass('is_select')
        }
      })
      parent.toggleClass('is_select')
    }) 
  }
  async function sliderNavAction(){
    const el = '.t4s-sec-slideshow .slide_nav_mibao .item'
    await MB_waitElementReady(el, preTime=500, total=100)
    $(el).click(function(){
      const nav = $(this).parent()
      const parent = nav.parent()
      const index = nav.find('.item').index(this)
      MB_flickity_carousel_select_cell(parent, index)
    })
    await MB_sleep(200)
    $('.t4s-sec-slideshow .slide_nav_mibao').each(function(){
      const nav = $(this)
      const parent = nav.parent()
      const el = parent.find('.t4s-flicky-slider')[0]
      const carousel = el.flickityt4s.$carousel
      carousel.on("select.flickityt4s", async function (t, index) {
        nav.find('.item').removeClass('is_select')
        $(nav.find('.item')[index]).addClass('is_select')
      });
    })
    
  }
  async function buyItNow0(){
    let is_buy_now = false
    const el = '.buy_it_now_mibao'
    await MB_waitElementReady(el, preTime=100, total=100)
    $(el).click(function(e){
      is_buy_now = true
      e.preventDefault()
      const form = $(this).parents('form')
      form.find('.t4s-product-form__submit').click()
      $(this).attr('disabled',true)
      $(window).on("cart:updated", ()=>{
        if(is_buy_now){
          console.log('added to cart')
          $('[data-cart-wrapper]').attr('aria-hidden', true)
          $('.t4s-close-overlay').removeClass('is--visible')
          $('body').removeClass('t4s-lock-scroll')
          $('body').removeClass('is--opend-drawer')
          $(this).removeAttr('disabled')
          is_buy_now = false
          // location.href = '/checkout'
        }
      })
    })
  }
  async function buyItNow(){
    const el = '.buy_it_now_mibao'
    await MB_waitElementReady(el, preTime=100, total=100)
    $(el).click(async function(e){
      $(this).attr('disabled',true)
      $(this).attr('aria-disabled',true)
      $(this).addClass('is--loading')

      e.preventDefault()
      const $form = $(this).closest('form')
      // const product = JSON.parse($form.parents('[data-product-featured]').attr('data-product-featured'))
      // const Color = $form.find('.is-sw__color').data('value')
      // const quantity = $form.find('[data-quantity-value]').val()
      const quantity = 1
      const id = MB_getUrlParam('variant') || meta.product.variants[0].id
      const items =  [{
          id,
          quantity,
      }]
      $form.find("input[name='compatible_accessories']").each(function(i, el){
          if (el.checked) {
            items.push({
                'id': el.value,
                quantity
            })
          }
      })
      
      const data = {
        form_type: "product",
        utf8: "✓",
        items,
        // id,
        // Color,
        // quantity,
      }

      console.log(data)
      const response = await MB_apiFetch(`${T4Sroutes.cart_add_url}.js`, "POST", data)
      // console.log(response)
      $(this).removeAttr('aria-disabled')
      $(this).removeClass('is--loading')
      $(this).removeAttr('disabled')
      location.href = '/checkout'
    })
  }
  async function bannerBuyNowButtonHandle(){
    const el = '.banner_buy_now_button a.t4s-btn'
    await MB_waitElementReady(el, preTime=100, total=100)
    $('.banner_buy_now_button a.t4s-btn').click(function(e){
      $('.buy_it_now_mibao').click()
      e.preventDefault();
    })
  }

  async function modalt4s_opened_handle(e){
    console.log("modalt4s:opened",e )
    const div_class = $('.t4s-modal.t4s-modal--is-active .t4s-modal__content>div').attr('class')
    $('body').addClass('t4s-lock-scroll')
    // console.log(div_class)
    if(/t4s-product-quick-view/i.test(div_class)){
      // console.log("is quick view")

      $('.t4s-modal.t4s-modal--is-active .t4s-product-quick-view .t4s-pr-addtocart').click(function(e){
        e.preventDefault()
        $('.t4s-modal.t4s-modal--is-active .t4s-product-quick-view .t4s-product-form__submit').click()
      })
      MB_buyItNowAtListItem()

      $('.t4s-modal.t4s-modal--is-active .t4s-product-quick-view select[id^="product-select"]').on('change',function(e){
        // console.log("is quick view  color change", $(this).val())
        const price = $('.t4s-modal.t4s-modal--is-active .t4s-product-quick-view .t4s-product__price-review .t4s-product-price ins').text()
        $('.t4s-modal.t4s-modal--is-active .t4s-product-quick-view .product_buttons .t4s-product-price ins').text(price)
      })
    }

  }
  async function modalt4s_closed_handle(e){
    $('body').removeClass('t4s-lock-scroll')
  }

  async function cart_discount_apply(e){
    // console.log("cart_discount_apply",e )
    const el = 'form[action="/cart"] .btn_apply_discount'
    await MB_waitElementReady(el)
    await MB_sleep(500)
    $(el).each(async function(){
      $parent = $(this).closest('form[action="/cart"]')
      const $discount_code = $parent.find('#CartDiscountcode')
      
      $discount_code.off('input').on('input', function(){
        $parent.find('.discount_info').show()
      })

      $(this).off('click').on('click', async function(){
        console.log('set discount code')
        $(this).attr('aria-disabled',true)
        $(this).addClass('is--loading')

        const discount_code = $parent.find('#CartDiscountcode').val()
        if(discount_code){
          const url = '/discount/' + discount_code
          console.log(url)
          await $.get(url)
          await MB_sleep(300)
          if($parent.attr('class').indexOf('t4s-drawer__wrap') >=0 ){
            T4SThemeSP.Cart.getToFetch(true)
            $(this).removeAttr('aria-disabled',true)
            $(this).removeClass('is--loading')
          }else{
            window.location.reload()
          }

        }
      })
    })
  }
  async function cart_show_discount(e){
    // console.log("t4s-cart_discounts",e )
    const el = 'form[action="/cart"] .t4s-cart_discounts'
    await MB_waitElementReady(el)
    await MB_sleep(100)
    $(el).each(function(){
      $parent = $(this).closest('form[action="/cart"]')
      // console.log('show discount code')
      if($parent.find('.t4s-cart_discounts').length){
        $parent.find('.show_discount').off('click').on('click', function(){
          $parent.toggleClass('show_discount')
        })
      }else{
        $parent.find('.show_discount').hide()
      }
    })
  }
  async function copy_discount_info_code_to_clipbroad(){
    const element = '.discount_info_wrap .discount_info_code'
    await MB_waitElementReady(element)
    const code = $(element).data('code')
    $(element).find('a').click(function(e){ 
      navigator.clipboard.writeText(code).then(() => {
        // console.log(`Code copied to clipboard: ${code}`);
        // alert(`Code copied to clipboard: ${code}`)
        $(this).text('Copied')
        $(this).addClass('copied')
      }).catch(err => {
        console.error('Failed to copy: ', err);
      });
      e.preventDefault();
    })
  }
  function init(){
    MB_jsDeferHandle(menuCollectionList, ['jQuery'])
    MB_jsDeferHandle(pcMenuAction, ['jQuery'])
    MB_jsDeferHandle(mobileMenuAction, ['jQuery'])
    MB_jsDeferHandle(sliderNavAction, ['jQuery'])
    MB_jsDeferHandle(MB_buyItNowAtListItem, ['jQuery'])
    MB_jsDeferHandle(cart_discount_apply, ['jQuery', 'T4SThemeSP'])
    MB_jsDeferHandle(cart_show_discount, ['jQuery', 'T4SThemeSP'])
    MB_jsDeferHandle(copy_discount_info_code_to_clipbroad, ['jQuery'])
    
    if(location.pathname == '/'){
      // MB_jsDeferHandle(setHome3Video, ['T4SThemeSP','onYouTubeIframeAPIReady'])
      MB_jsDeferHandle(userRecommendedListHandle, ['jQuery'])
      MB_jsDeferHandle(blogTrendingRecipesHandle, ['jQuery'])
    }
    if(/collections\/(\S+)?(\?|$)/.test(location.pathname)){
      // MB_jsDeferHandle(collectionFilterHandle, ['jQuery'])
      MB_jsDeferHandle(faqListHandle, ['jQuery'])
    }
    if(/products(_preview)?(\/)?(\S+)?(\?|$)/.test(location.pathname)){
      MB_jsDeferHandle(faqListHandle, ['jQuery'])
      MB_jsDeferHandle(buyItNow, ['jQuery'])
      MB_jsDeferHandle(bannerBuyNowButtonHandle, ['jQuery'])
    }
    $(window).on('NTpopupInline:offClose', function(e){
      console.log('NTpopupInline:offClose', e)
      $('body').addClass('t4s-lock-scroll')
    })
    $(window).on('NTpopupInline:onClose', function(e){
      console.log('NTpopupInline:onClose', e)
      $('body').removeClass('t4s-lock-scroll')
    })
    $(window).on('modalt4s:opened', function(e){
      console.log('modalt4s:opened',e )
      modalt4s_opened_handle(e)
    })
    $(window).on('modalt4s:closed', function(e){
      console.log('modalt4s:closed',e)
      modalt4s_closed_handle(e)
    })
    $(window).on('cart:updated', async function(e){
      console.log('cart:updated')
      cart_show_discount(e)
      cart_discount_apply(e)
      await MB_sleep(10)
      T4SThemeSP.initCarousel()
    })
    $(window).on('add:cart:success', async function(e){
      console.log('add:cart:success')
      $('.t4s-drawer__scroll').scrollTop(0)
    })
    $(window).on('cart:refresh:opend', function(e){
      console.log('cart:refresh:opend')
    })
    $(window).on('init:mini_cart', async function(e){
      console.log('init:mini_cart')
      await MB_sleep(1000)
      // 初始化购物车的产品列表
      T4SThemeSP.initCarousel()
    })
  }
  MB_jsDeferHandle(init, ['jQuery'])
  
}) ()